import { createAsyncThunk } from "@reduxjs/toolkit";
import { environment } from "../../environments";
import {
  CreateUserMsgTemplateRequest,
  CreateUserMsgTemplateResponse,
  GetAllUserMsgTemplatesRequest,
  GetAllUserMsgTemplatesResponse,
  DeleteUserMsgTemplateRequest,
  DeleteUserMsgTemplateResponse,
  GetMsgTemplateTagsRequest,
  GetMsgTemplateTagsResponse,
} from "../../models/MsgTemplate.model";

const API_URL = environment.apiUrl;

/**
 * שליפת כל תבניות ההודעות
 */
export const getAllUserMsgTemplates = createAsyncThunk<
  GetAllUserMsgTemplatesResponse,
  GetAllUserMsgTemplatesRequest,
  { rejectValue: string }
>(
  "msgTemplate/getAllUserMsgTemplates",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}MsgTemplate/GetAllUserMsgTemplates`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetAllUserMsgTemplatesResponse = await response.json();

      if (!data.success)
        return rejectWithValue(
          data.message || "Failed to fetch templates",
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);

/**
 * יצירה / עדכון תבנית הודעה
 */
export const createUserMsgTemplate = createAsyncThunk<
  CreateUserMsgTemplateResponse,
  CreateUserMsgTemplateRequest,
  { rejectValue: string }
>(
  "msgTemplate/createUserMsgTemplate",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}MsgTemplate/CreateUserMsgTemplate`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: CreateUserMsgTemplateResponse = await response.json();

      if (!data.success)
        return rejectWithValue(
          data.message || "Failed to save template",
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);

/**
 * מחיקת תבנית הודעה
 */
export const deleteUserMsgTemplate = createAsyncThunk<
  DeleteUserMsgTemplateResponse,
  DeleteUserMsgTemplateRequest,
  { rejectValue: string }
>(
  "msgTemplate/deleteUserMsgTemplate",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}MsgTemplate/DeleteUserMsgTemplate`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: DeleteUserMsgTemplateResponse = await response.json();

      if (!data.success)
        return rejectWithValue(
          data.message || "Failed to delete template",
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);

/**
 * רזולוציית תגיות תבנית — מקבלת TemplateID + ContactID ומחזירה גוף ממולא
 */
export const getMsgTemplateTags = createAsyncThunk<
  GetMsgTemplateTagsResponse,
  GetMsgTemplateTagsRequest,
  { rejectValue: string }
>(
  "msgTemplate/getMsgTemplateTags",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_URL}MsgTemplate/GetMsgTemplateTags`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: GetMsgTemplateTagsResponse = await response.json();

      if (!data.success)
        return rejectWithValue(
          data.message || "Failed to resolve template tags",
        );
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
